import { createGlobalStyle } from 'styled-components'
import { breakpoint } from './mixins'

const CSSGlobal = createGlobalStyle`
  html, body {
    height: 100%;
    margin: 0;
    padding: 0;
    width: 100%;
    font-size: ${({ theme }) => theme.fontSizeResponsive};

    ${breakpoint.up('desktop')`
      font-size: ${({ theme }) => theme.fontSizeMobile};
    `}
  }

  body {
    color: ${({ theme }) => theme.colorPrimary};
    font-family: ${({ theme }) => theme.fontFamilyPrimary};
    height: 100%;
    line-height: ${({ theme }) => theme.lineHeightRegular};
    overflow-x: hidden;
    width: 100%;
    background: ${({ theme }) => theme.colorBackground};
    padding: ${({ theme }) => theme.gutter};
  }

  body.has-modal {
    height: 100%;
    overflow: hidden;
  }

  strong {
    font-weight: 500;
  }

  em {
    font-style: italic;
  }

  a {
    color: inherit;
    text-decoration: underline;
  }

  p {
    margin-top: 0;
    font-size: 1em;
  }

  p + p {
    margin-top: ${({ theme }) => theme.lineHeightRegular};
  }

  img {
    width: 100%;
    display: block;
  }

  hr {
    width: 100%;
    height: 1px;
    border: 0;
    background: rgba(0, 0, 0, 0.1); 
    margin: ${({ theme }) => theme.gutter} 0;
  }

  input, select, button, textarea {
    &:focus {
      outline: 0;
    }
  }

`
export default CSSGlobal